export const ANALYTICS_REQUEST = 'IMP/ANALYTICS/REQUEST';
export const ANALYTICS_SUCCESS = 'IMP/ANALYTICS/SUCCESS';
export const ANALYTICS_LOADING = 'IMP/ANALYTICS/LOADING';
export const ANALYTICS_ERROR = 'IMP/ANALYTICS/ERROR';
export const ANALYTICS_CANCEL = 'IMP/ANALYTICS/CANCEL';

export const getAnalyticsReport = (type, id = 'default', params) => ({
  id,
  ...params,
  type: ANALYTICS_REQUEST,
  reportType: type,
});
